export class GetCurrentUser {
  public static readonly type = "[Users] Get Current User";
  public constructor() {}
}
